module.exports = __webpack_public_path__ + "img/weibo.162a9cce.png";